<template>
    <div class="upload-item">
        <div :class="[uploadFile.status]" class="upload-title">
            <div class="upload-title__name">{{ uploadFile.name }}</div>
            <div v-if="uploadFile.errorMessage" class="upload-title__error">{{ uploadFile.errorMessage }}</div>
        </div>
        <progress :class="{
            'upload-progress':true,
            'upload-progress--failed':uploadFile.status === 'fail',
            'upload-progress--canceled':uploadFile.status === 'cancel'
        }"
                  :value="uploadFile.progress"
                  max="100">

        </progress>
        <div class="upload-status">
            <span class="txt-desc">{{ statusMsg }}</span>
        </div>
        <div class="upload-item-delete">
            <button v-if="uploadFile.status === 'cancel'" class="btn--icon btn--ghost none--hover"
                    @click="handleResend">
                <i aria-hidden="true" class="icon icon-xs icon-refresh"/>
            </button>
            <button v-else class="btn--icon btn--ghost none--hover" @click="handleCancel">
                <i aria-hidden="true" class="icon icon-xs icon-close"/>
            </button>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';

export default {
    name: 'UploadProgress',

    mixins: [
        GlobalConfigMixin,
    ],

    props: {
        index: {
            type: Number,
            default: 0,
        },
        uploadFile: {
            type: Object,
            default: () => {
            },
        },
    },

    computed: {
        statusMsg() {
            switch (this.uploadFile.status) {
            case 'wait':
                return this.$t('words.upload_status_wait');
            case 'uploading':
                return `${this.uploadFile.progress}%`;
            case 'done':
                return this.$t('words.upload_status_done');
            case 'cancel':
                return this.$t('words.upload_status_cancel');
            case 'fail':
                return this.$t('words.upload_status_fail');
            default:
                return '';
            }
        },
    },

    methods: {
        handleCancel() {
            if (this.uploadFile.status === 'uploading') {
                this.uploadFile.source.cancel('User canceled');
            } else {
                this.$emit('setRemoveUploadFile', this.uploadFile.id);
            }
        },
        handleResend() {
            this.$emit('resendUploadFile', this.uploadFile.id);
        },
    },
};
</script>
